module.exports = __webpack_public_path__ + "static/media/32_B.e8a50079.png";